import {useTranslation} from '@aboutyou/i18n';
import {
  Button,
  GenericIconName,
  Heading16,
  Icon,
  ModalDialog,
  Text,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
interface FeedbackModalProps {
  isOpen: boolean;
  onClickClose: VoidFunction;
}

export const FeedbackModal = ({isOpen, onClickClose}: FeedbackModalProps) => {
  const {t} = useTranslation();
  return (
    <ModalDialog
      open={isOpen}
      onClose={onClickClose}
      showCloseIcon
      bodyContent={
        <Content>
          <Icon size="M" asset={GenericIconName.AlertSuccess} />
          <Heading16>{t('Thanks for the feedback!')}</Heading16>
          <Text size="px12" weight="light" color="Grey1">
            {t(
              'Your feedback is very important to us. It helps us improve our service.',
            )}
          </Text>
        </Content>
      }
      footerContent={
        <Button
          type="secondary"
          withBorder
          disableShadow
          onClick={onClickClose}
        >
          {t('Close')}
        </Button>
      }
    />
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
`;
